<template>
    <pm-simple-component-layout hide-footer>
        <template slot="title">
            DentiCalc
        </template>
        <div style="-webkit-overflow-scrolling: touch; position: fixed; right: 0; bottom: 0; left: 0; top: 52px; overflow-y: scroll;">
            <iframe src="https://bright-plans.com/index.html?ref=denticalc" frameborder="0" width="100%" height="100%" scrolling="yes" />
        </div>
    </pm-simple-component-layout>
</template>

<script>
import PmSimpleComponentLayout from "@/components/core/pm-simple-component-layout";

export default {
    components: {
        PmSimpleComponentLayout,
    },

    data: () => {
        return ({
            prevRoute: '/',
        });
    },
    created() {
        // window.location.href = "https://bright-plans.com/dc2.html?ref=denticalc";
    },

    computed: {
        isIOS() {
            return !!navigator.platform && /iPad|iPhone|iPod|MacIntel/.test(navigator.platform);
        },
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },

    methods: {
        toolbarBack() {
            this.$router.push(this.prevRoute);
        },
    }
};
</script>
